import script from "./EditorHtmlFieldBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorHtmlFieldBlock.vue?vue&type=script&setup=true&lang=js"

import "./EditorHtmlFieldBlock.vue?vue&type=style&index=0&id=36f9d76b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f9d76b"]])

export default __exports__